import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import UserQuestions from '../components/UserQuestions';
import {SimpleSection} from '../components/Section';
import LoadingSpinner from '../components/LoadingSpinner';

const QuestionsPage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    checkAuthStatus();
  }, []);

  async function checkAuthStatus() {
    try {
      await Auth.currentAuthenticatedUser();
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <LoadingSpinner message="Loading your questions..." />;
  }

  if (!isAuthenticated) {
    return (
      <SimpleSection>
        <Alert variant="warning">
          <Alert.Heading>Authentication Required</Alert.Heading>
          <p>
            You need to be logged in to view your questions. Please go to the{' '}
            <Alert.Link onClick={() => navigate('/user')}>
              user page
            </Alert.Link>{' '}
            to sign in or register.
          </p>
        </Alert>
      </SimpleSection>
    );
  }

  return (
    <>
      <SimpleSection>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2>Your Questions</h2>
          <Button 
            variant="primary" 
            onClick={() => navigate('/user/ask')}
          >
            Ask New Question
          </Button>
        </div>
      </SimpleSection>
      <SimpleSection>
        <UserQuestions />
      </SimpleSection>
    </>
  );
};

export default QuestionsPage;
